/**
 * What a campaign is (PAUL-3689), set at creation and read-only afterwards. A newsletter goes to the
 * subscribers of a newsletter and carries an unsubscribe link; a service mail goes to the members of
 * an audience list, subscribed or not, and has no unsubscribe link.
 */
export enum NewsletterCampaignKind {
  Newsletter = 0,
  ServiceMail = 1,
}

export const newsletterCampaignKindTranslations: Record<NewsletterCampaignKind, string> = {
  [NewsletterCampaignKind.Newsletter]: 'newsletter.kind.newsletter',
  [NewsletterCampaignKind.ServiceMail]: 'newsletter.kind.service_mail',
};

export const newsletterCampaignKindOptions = [
  {
    text: newsletterCampaignKindTranslations[NewsletterCampaignKind.Newsletter],
    val: NewsletterCampaignKind.Newsletter,
  },
  {
    text: newsletterCampaignKindTranslations[NewsletterCampaignKind.ServiceMail],
    val: NewsletterCampaignKind.ServiceMail,
  },
];
